import { useCallback, useState } from 'react';
import {
  applyAccent,
  readStoredAccent,
  writeStoredAccent,
  type AccentName,
} from '../lib/theme';

export function useAccent() {
  const [accent, setAccentState] = useState<AccentName>(() => readStoredAccent());

  const setAccent = useCallback((next: AccentName) => {
    writeStoredAccent(next);
    applyAccent(next);
    setAccentState(next);
  }, []);

  return { accent, setAccent };
}
